import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { LessonWalkthrough } from '../components/adventure/LessonWalkthrough';
import { BadgeShelf } from '../components/adventure/BadgeShelf';
import { featuredLesson } from '../lib/appAssets';
import { APP_STATUS } from '../lib/links';
export function Adventure() {
  return <>
      <section aria-labelledby="adventure-heading" className="bg-lavender-soft pb-20 pt-8 md:pb-24 md:pt-10" data-id="element-344" data-mp="227j2r6qpr71x">
        <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-345" data-mp="1x97s4tslgsin">
          <Breadcrumbs data-id="element-346" data-mp="1xaspssa7grkq" />

          <div className="mx-auto mt-6 max-w-2xl text-center" data-id="element-347" data-mp="2b87ic5vr9fgx">
            <h1 id="adventure-heading" className="font-display text-[38px] leading-tight tracking-tight text-ink md:text-[52px]" data-id="element-348" data-mp="2b9s8zkey8e9i">
              Try a little adventure.
            </h1>
            <p className="mt-4 text-[18px] text-ink-soft" data-id="element-349" data-mp="3mm1jlgpwyicl">
              “{featuredLesson.title}” from {featuredLesson.world}, card by card. This is a free sample in your
              browser, not a subscription trial. No account, payment or email needed.
            </p>
          </div>

          <div className="mt-10 md:mt-12" data-id="element-350" data-mp="1znqle70j8l5y">
            <LessonWalkthrough data-id="element-351" data-mp="1zqwa3l591l15" />
          </div>

          <p className="mt-8 text-center text-[16px] text-ink-soft" data-id="element-352" data-mp="23rpy0eioyzu1">
            {APP_STATUS}.{' '}
            <Link to="/worlds" className="font-bold text-ink underline decoration-coral decoration-2 underline-offset-4" data-id="element-353" data-mp="28ogg17e245i3">
              See every world
            </Link>
          </p>
        </div>
      </section>

      <BadgeShelf data-id="element-354" data-mp="1g1lvkah8p64m" />
    </>;
}